import * as yup from "yup";

import { FORM_FIELDS } from "@constants/form";

export const MAINTENANCE_VALIDATION = FORM_FIELDS.INVENTORY.MAINTENANCE;

export const maintenanceValidationSchema = yup.object().shape({
  [MAINTENANCE_VALIDATION.NAME]: yup
    .string()
    .required("Product name is required"),
  [MAINTENANCE_VALIDATION.ISSUE_NAME]: yup
    .string()
    .required("issue name is required"),
});

export const maintenanceDetailValidationSchema = yup.object().shape({
  [MAINTENANCE_VALIDATION.EMPLOYEE_ID]: yup.number().when("check", {
    is: 1,
    then: (schema) => schema.required("employee Id is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [MAINTENANCE_VALIDATION.BOOK_START_DATE]: yup.string().when("check", {
    is: 1,
    then: (schema) => schema.required("book start date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),

  [MAINTENANCE_VALIDATION.BOOK_END_DATE]: yup.string().when("check", {
    is: 1,
    then: (schema) => schema.required("book end date is required"),
    otherwise: (schema) => schema.notRequired(),
  }),
});

export type MaintenanceValidationSchemaType = yup.InferType<
  typeof maintenanceValidationSchema
>;

export type MaintenanceDetailValidationSchemaType = yup.InferType<
  typeof maintenanceDetailValidationSchema
>;
